export default __webpack_public_path__ + "static/media/columnViewBlue.3bff1cc8.svg";